const START_YEAR = 2026;
const NUMERALS = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X',
    'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX'];

export function initVolume() {
    const vol = new Date().getFullYear() - START_YEAR + 1;
    const roman = NUMERALS[vol - 1] || String(vol);

    document.querySelectorAll('[data-volume]').forEach(el => {
        el.textContent = roman;
    });
}
